import { translateInventoryText } from '@/shared/i18n/inventory-i18n';

export const OUTSIDE_BUILDING_SELECT_VALUE = '__outside__';

export function readBuildingNameLabel(buildingName: string) {
  return buildingName === OUTSIDE_BUILDING_SELECT_VALUE
    ? translateInventoryText('app.inventory.position.building.outsideNotSpecified', 'Outside / not specified')
    : buildingName;
}
